import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/kontaktpersoner',
    name: 'Kontaktpersoner',
    component: () => import('./views/Kontaktpersoner.vue')
  }
]

export default routes
